import { get, isBoolean, pick, pickBy } from 'lodash';
import { SPAN_SCOPE_METRICS_ATTRIBUTES } from '../config/spanScopeMetricAttributes';

export const getTraceMetricAttributes = span => {
    const allowedKeys = get(SPAN_SCOPE_METRICS_ATTRIBUTES, span.name, []);

    const spanAttributes = {
        traceScope: span.name,
        ...pick(span.attributes, allowedKeys),
    };
    const metericAttributes = pickBy(spanAttributes, value => !isBoolean(value) || value);
    return metericAttributes;
};
